import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalCacheService } from '../../core/local-cache/local-cache.service';
import { UserService } from '../../core/user/user.service';
import { ServiceType } from '../../shared/_enum/constants';
import { AssetHarvesterVersion } from '../_enum/constants';


@Injectable({
  providedIn: 'root'
})
export class AHNavigationResolverService  {

  constructor(private router: Router,
    private localCacheService: LocalCacheService,
    private userService: UserService) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const currentUrl = state.url;
    const id = route['_routerState'].url;
    if (id === '/assetharvester') {

      // Always stay on the new Asset Harvester (AH 2.0).
      const version = AssetHarvesterVersion['AssetHarvester2'];
      this.localCacheService.storeData('AH_version', version.version, 'session');

      if (currentUrl !== version.baseUrl) {
        this.router.navigate([version.baseUrl]);
      }
      return null;
    }
    else {
      return null
    }

  }
}
